module.exports = __webpack_public_path__ + "static/img/logo-5-5.1be6d92f.png";